import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="pt-40 text-center text-[#333333]" data-testid="auth-loading">Caricamento…</div>;
  if (user === false) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return children;
}
